<template>
    <section class="margin-both-lg">
        <div class="inner container">
            <h2 v-if="data.section_title" class="titler margin-bottom">{{data.section_title}}</h2>
            <div v-if="data.links" class="links-list">
                <template v-for="(link, k) in data.links" v-if="link.acf_fc_layout === 'link'">
                    <Button v-if="link.link && link.link.url" type="darkLight" :key="k"  hasIcon :iconType="linkType(link.link.url)" link :aria-label="link.link.title">
                        <AcfLink :data="link.link" />
                    </Button>
                </template>
                <template v-else>
                    <Button v-if="link.file && link.file.url" type="darkLight" :key="k"  hasIcon iconType="download" link :aria-label="link.file.title">
                        <a :href="link.file.url" target="_blank" download>{{link.file.title || link.file.filename}}</a>
                    </Button>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import Button from '@/components/elements/Button'
import AcfLink from '@/components/elements/AcfLink'

export default {
    name: 'link-buttons',
    props: ['data'],
    computed:{
        
    },
    methods:{
        linkType(link){
            const home = window.WPVUE.home
            return link.includes(home) ? 'link' : 'external'
        }
    },
    components:{
        Button,
        AcfLink
    },
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.module-links_block{
    .inner{
        
    }
    .links-list{
        .fill-button{
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
            &:last-child{
                margin-bottom: 0;
            }
            .icon{
                margin-right: 25px;
            }
        }
    }
    .container{
        max-width: 800px;
    }
}
</style>